<template lang="pug">
main
  PmHeader
  .container
    br
    article.message.is-info
      .message-header
        p Servidor de Correo
      .message-body
        .p
          strong Servidor:
          | {{ ' ' + correoConfig.servidor }}
        .p
          strong Puerto:
          | {{ ' ' + correoConfig.puerto }}
        .p
          strong Dirección:
          | {{ ' ' + correoConfig.direccion }}
        br
        a.button.is-info(@click="editar") Editar 
    br
    .modal(v-bind:class="{'is-active':isEditing}")
        .modal-background
        .modal-card
          header.modal-card-head
            p.modal-card-title Servidor de Correo
          section.modal-card-body
              p 
                strong Servidor:
                input.input(type='text' v-model='servidor' placeholder='smtp.miservidor.com')
              p 
                strong Puerto:
                input.input(type='text' v-model='puerto' placeholder='465')
              p 
                strong Dirección:
                input.input(type='email' v-model='direccion' placeholder='info@miservidor.com')
              p 
                strong Contraseña:
                input.input(type='password' v-model='clave')
          footer.modal-card-foot
            button.button.is-success(@click='closeAndUpdateCorreoConfig') Aplicar
            button.button.is-link(@click='closeCorreoConfig') Cancelar
        button.modal-close.is-large(@click='closeCorreoConfig')
</template>
<script>
import correoService from '../services/correoService'
import PmHeader from '../components/layout/Header.vue'

export default {
  components: {
    PmHeader
  },

  data: () => ({
    correoConfig: {},
    isLoading: false,
    isEditing: false,
    showNotification: false,
    servidor: ``,
    puerto: 465,
    direccion: ``,
    clave: ``
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  methods: {
    getConfiguracionCorreo () {
      this.isLoading = true
      correoService.correoConfig(localStorage.getItem('token'))
        .then(res => {
          this.showNotification = res.length === 0
          this.correoConfig = res
          this.isLoading = false
        })
        .catch(() => {
          console.log(`No existe la configuración del servidor de correos`)
        })
    },

    editar () {
      this.isEditing = true
      this.servidor = this.correoConfig.servidor
      this.puerto = this.correoConfig.puerto
      this.direccion = this.correoConfig.direccion
      this.clave = ``
    },

    closeAndUpdateCorreoConfig () {
      let data = {
        servidor: this.servidor,
        puerto: this.puerto,
        direccion: this.direccion,
        clave: this.clave
      }

      if (this.clave.length > 0 ) {
        correoService.correoConfigActualizar(data, localStorage.getItem('token'))
        .then(res => {
          this.correoConfig = res
        })
        
        this.isEditing = false;
        this.clave = ``
      }      
    },

    closeCorreoConfig () {
      this.isEditing = false;
    }
  },

  beforeMount () {    
    this.getConfiguracionCorreo()
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: left;
}
</style>
